<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Robot Family Metadata: {{ metadata.robot_family }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Robot Family</div>
        <div>{{ metadata.robot_family }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Metadata Type</div>
        <div>{{ metadata.metadata_type }}</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Metadata Table</h5>
    <hr />

    <div class="mb-5">
      <app-metadata-table-cell [tableData]="metadata.metadata"></app-metadata-table-cell>
    </div>

    <h5 class="mb-0" i18n>Metadata</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Created By</div>
        <div>{{ metadata.created_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Created On</div>
        <div>{{ metadata.created_dttm | customValueHandling: 'created_dttm' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Last Updated By</div>
        <div>{{ metadata.last_updated_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated On</div>
        <div>{{ metadata.last_updated_dttm | customValueHandling: 'last_updated_dttm' }}</div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
